import {
    IQueryOptions,
    IQueryKeyValue,
} from '@kurtosys/ksys-api-client/dist/models/commonTypes';

export default function pivotQueryCollection(
    queries: Array<IQueryOptions>
): IQueryKeyValue {
    return queries.reduce((obj, item) => {
        obj[item.queryId] = item;
        return obj;
    }, {});
}



// WEBPACK FOOTER //
// ./src/utils/query/pivotQueryCollection.ts